/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_MeInputs */

const cs_billing_me = /** @type {(inputs: Billing_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Můj zůstatek`)
};

const en_billing_me = /** @type {(inputs: Billing_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My balance`)
};

/**
* | output |
* | --- |
* | "My balance" |
*
* @param {Billing_MeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_me = /** @type {((inputs?: Billing_MeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_MeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_me(inputs)
	return cs_billing_me(inputs)
});